<template><!-- svgo-optimised -->
<svg class="icon icon__pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect height="22" width="4" x="5" y="1" rx="1"/><rect height="22" width="4" x="15" y="1" rx="1"/></svg>
</template>